import React from "react";
import { FormattedMessage } from "react-intl";
import { View, Text, FlatList } from "react-native";
import { If, Then, Else } from "react-if";
import { styles } from "./styles";

const AllOrdersCard = ({ orders }) => {
  const renderItem = ({ item }) => (
    <>
      <View style={styles.order}>
        <View style={styles.firstRow}>
          <View style={styles.row}>
            <Text style={styles.label}>
              <FormattedMessage id="allOrdersCard.txtTipo" />
            </Text>
            <Text
              style={[
                styles.value,
                item.is_purchase ? styles.purchase : styles.sale,
              ]}
            >
              {item.is_purchase ? (
                <FormattedMessage id="allOrdersCard.txtOrdemCompra" />
              ) : (
                <FormattedMessage id="allOrdersCard.txtOrdemVenda" />
              )}
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>
              <FormattedMessage id="allOrdersCard.txtData" />
            </Text>
            <Text style={styles.value}>
              {new Date(item.created_at).toLocaleDateString("pt-BR") || "N/A"}
            </Text>
          </View>
        </View>
        <View style={styles.firstRow}>
          <View style={styles.row}>
            <Text style={styles.label}>
              <FormattedMessage id="allOrdersCard.txtQuantidade" />
            </Text>
            <Text style={styles.value}>{Math.round(item.quantity)}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>
              <FormattedMessage id="allOrdersCard.txtValor" />
            </Text>
            <Text
              style={[
                styles.value,
                item.is_purchase ? styles.purchase : styles.sale,
              ]}
            >
              {item.value_coin}
            </Text>
          </View>
        </View>
      </View>
      <View style={styles.divider} />
    </>
  );

  return (
    <View style={styles.card}>
      <Text style={styles.titleOrdersAndTrade}>
        <FormattedMessage id="allOrdersCard.txtHeaderOrdensGlobais" />
      </Text>
      <View style={styles.contentOrders}>
        <Text style={styles.orderPurchases}>
          <FormattedMessage id="token.ordensDe" />
        </Text>
        <Text style={styles.orderPurchasesBold}>
          <FormattedMessage id="token.compra" />
        </Text>
        <Text style={styles.orderPurchases}>
          <FormattedMessage id="token.e" />
        </Text>
        <Text style={styles.orderPurchasesBold}>
          <FormattedMessage id="token.venda" />
        </Text>
      </View>

      <View style={styles.divider} />

      <If condition={orders.length > 0}>
        <Then>
          <FlatList
            data={orders}
            renderItem={renderItem}
            keyExtractor={(item) => item.id.toString()}
          />
        </Then>
        <Else>
          <Text style={styles.noOrdersMessage}>
            <FormattedMessage id="allOrdersCard.txtSemOrdens" />
          </Text>
        </Else>
      </If>
    </View>
  );
};

export default AllOrdersCard;
